import { CalendarCheck2, FilePenLine, KeyRound, TrendingUp } from "lucide-react";
import { motion } from "framer-motion";

const steps = [
  [KeyRound, "Chase the right keyword", "Find a valuable topic with realistic ranking potential."],
  [FilePenLine, "Create useful content", "Generate, review, and strengthen a human-first SEO article."],
  [CalendarCheck2, "Schedule the work", "Place approved content on your simple internal calendar."],
  [TrendingUp, "Measure what happens", "Watch visitors arrive and use the signal to decide what comes next."],
];

export function HowItWorks() {
  return <section id="how-it-works" className="landing-section process-section" data-testid="how-it-works-section"><div className="landing-container">
    <div className="process-heading"><span>From idea to impact</span><h2>Your SEO workflow, without the tab chaos.</h2></div>
    <div className="process-line">{steps.map(([Icon,title,copy],index)=><motion.article initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index*.08 }} key={title} data-testid={`process-step-${index+1}`}><div className="step-number">{index+1}</div><Icon size={24}/><h3>{title}</h3><p>{copy}</p></motion.article>)}</div>
  </div></section>;
}
